import CountryFlag from "@/components/common/CountryFlag";
import { EsimPackage } from "@/lib/redux/features/esim/types";
import { getEsimInformationMeta } from "@/utils/esim/getEsimInformationMeta";
import { getEsimVariantSummary } from "@/utils/esim/getEsimCardDisplay";
// import { slugifyEsimGroupName } from "@/utils/esim/esimGroupSlug"; // chỉ dùng cho getEsimGroupNavigationUrl, tạm tắt cùng nút "Xem thêm"
import { ReactNode } from "react";

export type EsimPackageOption = {
  value: string;
  pkg: EsimPackage;
  label: ReactNode;
};

/** Shared AutoComplete option shape for both the free-text search box and the country picker's follow-up package list. */
export const buildEsimPackageOptions = (
  results: EsimPackage[],
  lang: string,
): EsimPackageOption[] =>
  results.map((pkg) => {
    const meta = getEsimInformationMeta(pkg, lang);
    const countryCode = pkg.countries?.[0];
    const title = meta.name || pkg.parentGroupName || pkg.gggPlanId;
    return {
      value: title,
      pkg,
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {countryCode ? <CountryFlag code={countryCode} size={18} /> : null}
          <span style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <span>{title}</span>
            <span style={{ fontSize: 12, opacity: 0.65 }}>
              {getEsimVariantSummary(pkg.data ?? "", pkg.validity ?? "")}
            </span>
          </span>
        </span>
      ),
    };
  });

/** Standalone detail page for exactly this esim (`POST /esim/catalog/public/detail`) — used when a search selects ONE specific package directly. */
export const getEsimPackageNavigationUrl = (pkg: EsimPackage): string =>
  `/esim-du-lich/goi/${encodeURIComponent(pkg.gggPlanId)}`;

// Bỏ nút "Xem thêm" (không còn dùng) — trang chi tiết 1 gói (`EsimPackageDetailView`) giờ đã tự có
// chip chọn Dung lượng/Thời hạn cùng nhóm, khiến trang "/esim-du-lich/nhom/[groupSlug]" thành bản
// thiếu tính năng hơn (không có "Bạn có thể quan tâm"/content CMS). Giữ lại hàm + route phòng khi
// cần dùng lại, không xoá hẳn.
// export const getEsimGroupNavigationUrl = (pkg: EsimPackage): string => {
//   const groupName = pkg.parentGroupName || pkg.gggPlanId;
//   const slug = slugifyEsimGroupName(groupName) || "nhom";
//   return `/esim-du-lich/nhom/${slug}?name=${encodeURIComponent(groupName)}`;
// };
